/* Colour cards (snippets/cj-colour-cards.liquid): the theme's own quick view, opened on the card's colour.
   The colour cards carry data-cjcc-pid instead of data-product-id, so the theme's hover preloader (theme.initQuickShop)
   skips them; it would load the same product's quick view once per colour card. This loads it once per product, on the
   first hover or focus of any of its cards, with the theme's own loader (theme.preloadProductModal), which binds every
   Quick view button of that product. On a Quick view click it waits for the modal to open and its form to load, then
   picks the card's colour and checks it took (the house pattern from cj-fb.js). No quick view below 769px, as in the theme. */
(function () {
  if (window.__cjcc) { return; }
  window.__cjcc = true;

  function small() { return !!(window.theme && theme.config && theme.config.bpSmall); }

  function warm(card) {
    var id = card.getAttribute('data-cjcc-pid'), handle = card.getAttribute('data-product-handle');
    var modal = id && document.getElementById('QuickShopModal-' + id);
    if (!modal || modal.getAttribute('data-cjcc-warm') || small()) { return; }
    if (!window.theme || typeof theme.preloadProductModal !== 'function') { return; }
    modal.setAttribute('data-cjcc-warm', '1');
    theme.preloadProductModal(handle, id, card.querySelector('.quick-product__btn'));
  }
  function onWarm(e) {
    var card = e.target && e.target.closest ? e.target.closest('.cjcc[data-cjcc-pid]') : null;
    if (card) { warm(card); }
  }
  document.addEventListener('mouseover', onWarm, { passive: true });
  document.addEventListener('focusin', onWarm);

  function pick(modal, opt, colour) {
    var wraps = modal.querySelectorAll('.variant-input[data-index="' + opt + '"]');
    for (var i = 0; i < wraps.length; i++) {
      if (wraps[i].getAttribute('data-value') !== colour) { continue; }
      var input = wraps[i].querySelector('input'), label = wraps[i].querySelector('label');
      if (input && input.checked) { return true; }
      if (label) { label.click(); } else if (input) { input.click(); }
      return false;
    }
    var sel = modal.querySelector('select[data-index="' + opt + '"]');
    if (sel) {
      if (sel.value === colour) { return true; }
      sel.value = colour;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return false;
  }
  function preselect(modal, opt, colour) {
    /* The theme fills the quick view form when the modal first opens and runs its form setup right after, so a colour
       picked too early is wiped: wait for open + loaded, let the setup settle, then pick and re-check (up to four tries). */
    var token = {}, tries = 0, picks = 0;
    modal.__cjccToken = token;
    (function wait() {
      if (modal.__cjccToken !== token) { return; }
      var open = modal.classList.contains('modal--is-active');
      var loaded = modal.querySelector('.product-form-holder--loaded') && modal.querySelector('.variant-input, select[data-index]');
      if ((!open || !loaded) && tries++ < 80) { setTimeout(wait, 150); return; }
      if (!open || !loaded) { return; }
      setTimeout(function attempt() {
        if (modal.__cjccToken !== token || !modal.classList.contains('modal--is-active')) { return; }
        if (pick(modal, opt, colour) || picks++ > 3) { return; }
        setTimeout(attempt, 600);
      }, 900);
    })();
  }
  window.cjccPreselect = preselect;   /* the fabric finder popup (cj-collection-cards) opens this quick view on its card's colour */
  /* capture phase: the theme's opener on the button stops the click, so arm the colour first and let the theme open it */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.cjcc .quick-product__btn') : null;
    if (!btn) { return; }
    var card = btn.closest('.cjcc');
    var modal = document.getElementById('QuickShopModal-' + card.getAttribute('data-cjcc-pid'));
    if (modal) { preselect(modal, card.getAttribute('data-cjcc-opt') || 'option1', card.getAttribute('data-cjcc-colour')); }
  }, true);
})();
